<script>
  export let blurred;

  import Emoji from "@helpers/Emoji.svelte";

  import { fade } from "svelte/transition";

  import IntersectionObserver from "svelte-intersection-observer";

  let element;
  let intersecting;

  import viewport from "@stores/viewport.js";
  import navigateToHash from "@helpers/navigateToHash.js";
  import { latestWorkableStep } from "@stores/userData.js";
</script>

{#if intersecting && blurred}
  <div class="blur-text" transition:fade>
    <h1>Wouldn't it be cool to look at this?</h1>
    <h2>
      Go submit your preferences above <Emoji
        emoji="monocle"
        styles="position: relative; width: 30px; height: 30px; margin-left: 6px;"
      />
    </h2>
  </div>
{/if}

<!-- Once the blurred section is 85% in view, show the blur text -->
<!-- {#key viewport.height} -->
<IntersectionObserver
  {element}
  bind:intersecting
  rootMargin="0px 0px {Math.round($viewport.height * -0.85)}px 0px"
>
  <div
    bind:this={element}
    class="blur-listener"
    on:click={() => {
      if (!blurred) return;
      navigateToHash(`${$latestWorkableStep}`, 0);
    }}
    class:blurred
  >
    <slot />
  </div>
</IntersectionObserver>

<!-- {/key} -->
<style>
  .blur-listener {
    transition: filter 500ms ease 1000ms;
  }

  .blurred {
    filter: blur(10px);
    cursor: not-allowed;
    /* cursor: n-resize; */
  }

  :global(.blurred *) {
    pointer-events: none !important;
    cursor: not-allowed !important;
    /* cursor: n-resize !important; */
  }

  .blur-text {
    z-index: 10000;
    position: fixed;
    top: 50%;
    left: 50%;
    width: 500px;
    transform: translate(-50%, -50%);
    filter: blur(0) !important;
    background: white;
    font-size: 1rem;
    padding: 1.75rem;
    text-align: center;
    box-shadow: 1px 3px 100px rgba(0, 0, 0, 0.5);
    border-radius: 5px;
    border: 3px solid var(--accent-color);
    user-select: none;
    -webkit-user-select: none; /* Chrome/Safari */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+ */
    pointer-events: none;
  }

  .blur-text h1 {
    font-size: 1.75rem;
    margin-bottom: 0.75rem;
    font-weight: 700;
  }

  .blur-text h2 {
    font-size: 1.25rem;
    color: rgba(0, 0, 0, 0.75);
    font-weight: 200;

    display: flex;
    justify-content: center;
    place-items: center;
  }

  @media screen and (max-width: 568px) {
    .blur-text {
      width: 95%;
    }

    .blur-text h1 {
      font-size: 1.5rem;
    }

    .blur-text h2 {
      font-size: 1rem;
      flex-direction: column;
    }

    :global(.blur-text h2 img) {
      margin-left: 0 !important;
      margin-top: 6px;
    }
  }
</style>
